import React, {CSSProperties, memo, useCallback, useMemo} from 'react';
import MemoCoinImage from "./CoinImage";
import polygon from "../assets/polygon.svg";
import eth from "../assets/ethereum.svg";
import binance from "../assets/binance.svg";
import klaytn from "../assets/klaytn.svg";
import solana from "../assets/solana.svg";
import metamask from "../assets/metamask.svg";
import phantom from "../assets/phantom.png";
import walletconnector from "../assets/walletconnector.svg";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleXmark, faCopy} from "@fortawesome/free-solid-svg-icons";
import {IWallet} from "../types/type";
import {toastSuccess} from "../toast";
import {useTranslation} from "react-i18next";


interface IEachCarousel {
    wallet : IWallet
    deleteWallet : (index : number) => void
    seq : number
}


const EachCarousel : React.FC<IEachCarousel> = ({wallet , deleteWallet , seq}) => {


    const {t} = useTranslation()

    const findCoinImage = useCallback((walletChainId: string): React.ReactNode => {
        const smallLogoCSS: CSSProperties = {width: '30px', height: '30px'}
        if (walletChainId === '137') {
            return <MemoCoinImage bgColor={'matic-bg-color'} logoSrc={polygon} coinName={'Polygon'} style={smallLogoCSS}/>
        } else if (walletChainId === '1') {
            return <MemoCoinImage bgColor={'eth-bg-color'} logoSrc={eth} coinName={'Ethereum'} style={smallLogoCSS}/>
        } else if (walletChainId === '56') {
            return <MemoCoinImage bgColor={'bsc-bg-color'} logoSrc={binance} coinName={'binance'} style={smallLogoCSS}/>
        } else if (walletChainId === '8217') {
            return <MemoCoinImage bgColor={'klay-bg-color'} logoSrc={klaytn} coinName={'klaytn'} style={smallLogoCSS}/>
        } else if (walletChainId === 'sol') {
            return <MemoCoinImage bgColor={'sol-bg-color'} logoSrc={solana} coinName={'solana'} style={smallLogoCSS}/>
        }
    },[])


    const findWalletIcon = useCallback((walletName: string): React.ReactNode => {
        if (walletName === 'metaMask' || walletName === 'metamask') {
            return <img className={'shadow-lg rounded-full p-0.5'} src={metamask} alt={'metaMask icon'} style={{'height': '30px'}}/>
        } else if (walletName === 'phantom') {
            return <img className={'shadow-lg rounded-full p-0.5'} src={phantom} alt={'phantom icon'} style={{'height': '30px'}}/>
        } else if (walletName === 'walletconnect') {
            return <img src={walletconnector} alt={'walletconnector icon'} style={{'height': '18px'}}/>
        }
    },[])


    const cardBackColor = () => {
        if (wallet.chainId === '137') {
            return ' bg-gradient-to-r from-violet-300 to-violet-400'
        } else if (wallet.chainId === '1') {
            return ' bg-gradient-to-r from-pink-300 via-purple-300 to-indigo-400'
        } else if (wallet.chainId === '56') {
            return ' bg-amber-300 text-white bg-gradient-to-l from-yellow-200 to-yellow-500'
        } else if (wallet.chainId === '8217') {
            return ' bg-gradient-to-r from-orange-400 to-rose-400'
        } else if (wallet.chainId === 'sol') {
            return ' bg-gradient-to-r from-green-300 via-blue-500 to-purple-600'
        }
    }


    const sliceWalletAddress = useMemo(() =>
            wallet.address.slice(0, 5) + "..." + wallet.address.slice((wallet.address.length - 1) - 5, wallet.address.length)
    , [wallet.address])


    const copyAddress = () => {
        navigator.clipboard.writeText(wallet.address)
        return toastSuccess(t('wallet-address-copied'))
    }


    return (
        <div className={'w-full h-full text-xs p-6 rounded-xl shadow-inner' + cardBackColor()} >
            <div className={'flex w-full justify-end'} onClick={() => deleteWallet(seq)}>
                <FontAwesomeIcon icon={faCircleXmark} className={'ml-1.5 text-red cursor-pointer'}/>
            </div>
            <div className={'flex items-center my-1.5'}>
                <p>{t('wallet-address')} : {sliceWalletAddress}
                    <FontAwesomeIcon
                        onClick={copyAddress}
                        icon={faCopy}
                        className={'text-slate-600 ml-0.5 cursor-pointer'}/>
                </p>

            </div>
            <div className={'flex items-center mt-3'}>
                <span className={'mr-3'}>{t('block-chain')} : </span>
                {findCoinImage(wallet.chainId)}
            </div>
            <div className={'flex items-center mt-2'}>
                <span className={'mr-1.5'}>{t('wallet-type')} : </span>
                {findWalletIcon(wallet.walletName)}
            </div>
        </div>
    );
}

export default memo(EachCarousel)